import { Component, Inject, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-commondialog',
  templateUrl: './commondialog.component.html',
  styleUrls: ['./commondialog.component.css']
})
export class CommondialogComponent implements OnInit, OnDestroy {
  private previouslyFocusedElement!: HTMLElement;

  constructor(
    public dialogRef: MatDialogRef<CommondialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.previouslyFocusedElement = document.activeElement as HTMLElement;
    const firstFocusableElement = this.elementRef.nativeElement.querySelector('button');
    firstFocusableElement.focus();
  }

  ngOnDestroy(): void {
    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}